var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#173CBA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497,0h-61c-8.3,0-15,6.7-15,15v15H298.2C292,12.6,275.5,0,256,0s-36,12.6-42.2,30H91V15c0-8.3-6.7-15-15-15 H15C6.7,0,0,6.7,0,15v60c0,8.3,6.7,15,15,15h61c8.3,0,15-6.7,15-15V59.8h61.6c-52.1,32.5-86.4,89.6-90.5,153.6 C44.1,219.3,31,236.1,31,256c0,24.8,20.2,45,45,45s45-20.2,45-45c0-19.1-12.1-35.4-28.9-41.9c5.1-71.3,54.9-131.4,124.1-148.6 C223.7,80,238.6,90,256,90s32.3-10,39.8-24.5c69.2,17.2,119,77.3,124.1,148.6c-16.9,6.5-28.9,22.8-28.9,41.9c0,24.8,20.2,45,45,45 s45-20.2,45-45c0-19.9-13.1-36.7-31.1-42.6c-4.1-64-38.4-120.9-90.5-153.4H421v15c0,8.3,6.7,15,15,15h61c8.3,0,15-6.7,15-15V15 C512,6.7,505.3,0,497,0z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358,493.4c-7.8-24-30.4-42.4-57-42.4h-90c-26.6,0-49.2,18.4-57.1,42.4c-3,9.3,4.9,18.6,14.6,18.6h174.9 C353.2,512,361.1,502.7,358,493.4z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M388.5,307.7L271,131.5v142.3c17.4,6.2,30,22.7,30,42.2c0,24.8-20.2,45-45,45s-45-20.2-45-45 c0-19.5,12.6-36,30-42.2V131.5L123.5,307.7c-4,5.9-3.2,13.9,1.9,18.9c27.5,27.5,45.1,63,51.9,101.1c10.4-4.2,21.8-6.7,33.7-6.7h90 c11.9,0,23.3,2.4,33.7,6.7c6.8-38.1,24.4-73.5,51.9-101.1C391.7,321.6,392.5,313.6,388.5,307.7z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,301c-8.3,0-15,6.7-15,15s6.7,15,15,15s15-6.7,15-15S264.3,301,256,301z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignIcon);
export default __webpack_public_path__ + "static/media/design-icon.831154b02fbeff2985732b50a2eb1a3f.svg";
export { ForwardRef as ReactComponent };